import { Controller } from "@hotwired/stimulus"

export default class RowLinkController extends Controller {
  static targets = [
    'notClick'
  ]

  static values = {
    url: String
  }

  click(e) {
    if (this.urlValue === null) return;
    if (this.notClickTargets.some(t => t.contains(e.target))) return;

    window.location = this.urlValue;
  }
}
